import React from "react";
import { useTranslation } from "react-i18next";
import { InputAutoresize } from "../../../common/components/form";

export default function WStepEmbed(props) {
    const { t } = useTranslation();

    const { set, isCustom, variables, variables2block } = props;

    const items = isCustom ? [variables2block] : [{ variables }];

    return (
        <div className="wizard-part-inner">
            <div style={{ flex: 1 }}>
                <h1>{t("WizardWStepVideoHeader")}</h1>

                {items.map((item, index) => (
                    <Item key={index} {...item} set={(...args) => set(...args, item)} />
                ))}
            </div>
        </div>
    );
}

function Item(props) {
    const { t } = useTranslation();

    const {
        set,
        variables: { Embed },
    } = props;

    const _Embed = Embed ?? [];

    function onItemChange({ name, value }) {
        let code = value;

        const parser = new DOMParser();
        const doc = parser.parseFromString(code, "text/html");

        const iframe = doc.querySelector("iframe");

        if (iframe) {
            let aspectRatio = "16 / 9";
            const width = iframe.getAttribute("width");
            const height = iframe.getAttribute("height");

            if (width && height) {
                aspectRatio = `${width} / ${height}`;
            }

            iframe.removeAttribute("width");
            iframe.removeAttribute("height");
            iframe.style.setProperty("width", `100%`, "important");
            iframe.style.setProperty("height", `auto`, "important");
            iframe.style.setProperty("aspect-ratio", aspectRatio);
            code = doc.body.innerHTML;
        }

        set({ Embed: { ...Embed, [name]: code } });
    }

    return (
        <>
            <div className="margin-top-40">
                <p>{t("WizardWStepEmbedText")}</p>
            </div>

            <div className="margin-top-40 grid-gap-40 grid-center">
                <div className="flex-gap-20 flex-center relative">
                    <div className="grid-gap-20 wizard-embed">
                        <InputAutoresize
                            className="full-width"
                            name="html"
                            onChange={({ target: { name, value } }) => onItemChange({ name, value }, _Embed[0])}
                            value={_Embed?.html || ""}
                            placeholder={t("WizardWStepEmbedTextAreaPlaceholder")}
                            rows="5"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
